import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";
import { useLocalizedSentenceDict } from "@hooks/useSentenceDict";

function LoginError() {
  const dict = useLocalizedSentenceDict();

  return (
    <>
      <p className="typo-body mb-[15px]">
        {dict.get(
          "We couldn't log you in. Please try again using the latest link sent to your email, or request a new one below."
        )}
      </p>
      <p className="typo-body">
        {dict.get("If you're still having trouble, contact our Customer Service team.")}
      </p>
    </>
  );
}

export default withALErrorBoundary({
  name: "LoginError",
  priority: "P1",
})(LoginError);
